import { z } from 'zod/v4';
import { isZipCodeRequired } from './company-address.js';

export const COMPANY_SIZE_VALUES = [
  'FROM_0_TO_1',
  'FROM_2_TO_10',
  'FROM_11_TO_50',
  'FROM_51_TO_200',
  'FROM_201_TO_500',
  'FROM_501_TO_1000',
  'FROM_1001_TO_5000',
  'FROM_5001_TO_10000',
  'FROM_10001_TO_INFINITE',
] as const;

export const COMPANY_TYPE_VALUES = [
  'EDUCATIONAL_INSTITUTION',
  'GOVERNMENT_AGENCY',
  'NONPROFIT',
  'PARTNERSHIP',
  'PRIVATELY_HELD',
  'FAMILY_BUSINESS',
  'PUBLIC_COMPANY',
  'SELF_EMPLOYED',
  'SOLE_PROPRIETORSHIP',
] as const;

export const CONNECTION_TYPE_VALUES = ['SUPPLIER', 'CLIENT'] as const;

export const CreateCompanyBodySchema = z
  .object({
    officialName: z.string().min(1).max(255),
    name: z.string().min(1).max(255).optional(),
    country: z.string().min(1),
    companySize: z.enum(COMPANY_SIZE_VALUES).optional(),
    companyType: z.enum(COMPANY_TYPE_VALUES).optional(),
    facilityProcesses: z.string().min(1),
    connectionType: z.enum(CONNECTION_TYPE_VALUES),
    onBehalfOfCompanyId: z.string().min(1).max(255).optional(),
    // The structured address is required for every company; see
    // `company-address.ts`. Zip code is optional only where the country has
    // no postal codes, which the refinement below enforces.
    addressLine1: z.string().trim().min(1),
    addressLine2: z.string().trim().optional(),
    city: z.string().trim().min(1),
    zipCode: z.string().trim().optional(),
    geojson: z.unknown().optional(),
  })
  .superRefine((body, ctx) => {
    if (isZipCodeRequired(body.country) && !body.zipCode) {
      ctx.addIssue({
        code: 'custom',
        path: ['zipCode'],
        message: 'Zip code is required for this country',
      });
    }
  });

export type CreateCompanyBody = z.infer<typeof CreateCompanyBodySchema>;
